import { useEffect, useState } from "react";

export const useProfilePlaceholder = () => {
    const [base64, setBase64] = useState('');
    const fetchImage = async () => {
        const response = await fetch('/profile_placeholder.jpg');
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
            setBase64(reader.result as string);
        };
        reader.readAsDataURL(blob);
    }
    useEffect(() => { fetchImage() }, []);
    return base64;
}